import { styled } from "@styles";

export const Wrapper = styled.div`
  img {
    max-width: 100%;
  }
`;
